import {dbPost} from 'utils/ajaxUtils';

export const Actions = {
  // breaks
  ValidateBreak: 'validate_break',
  PublishBreak: 'publish_break',
  UnpublishBreak: 'unpublish_break',

  // prizes
  PublishPrize: 'publish_prize',
  AwardPrizes: 'award_prizes',
  ManualEntry: 'manual_entry',
  DownloadReport: 'download_report',

  // entries/winners
  SelectWinners: 'select_winners',
  MakeFeatured: 'make_featured',
  MakeUnfeatured: 'make_unfeatured',
  PublishFeaturedStories: 'publish_featured_stories',

  // rewards
  ResendOrder: 'resend_order',
  AddStock: 'add_stock',
  RemoveStock: 'remove_stock',
  StockStore: 'stock_store',

  // user mgmt
  AwardPoints: 'award_points',
  AwardSpins: 'award_spins',
  AwardConsecutiveDays: 'award_consecutive_days',
  ChangeEmail: 'change_email',
  ChangePassword: 'change_password',
  RevokePoints: 'revoke_points',
  RepairProfile: 'repair_profile',
  DeactivateUser: 'deactivate_user',
  DeleteUserData: 'delete_user_data',
  CancelTransaction: 'cancel_transaction',
  ApproveSubmission: "approve_submission",
  ResendPrizeForSubmission: "resend_prize_for_submission",
  RejectSubmission: "reject_submission",
};

export const performAction = (type, action, data) => dbPost(`service/${type.toLowerCase()}/${action}`, {
  args: JSON.stringify(data)
});



// WEBPACK FOOTER //
// ./public/api/services.js